import * as React from "react";
import { useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import { useSoundContext } from "./Hooks/useGameSound";

const showBanner = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const pulse = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

const MyTurnBanner = styled.h1<{
  visible: boolean;
  fontSize: string;
  isActive?: boolean;
}>`
  font-size: ${({ fontSize }) => fontSize};
  line-height: ${({ fontSize }) => fontSize};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0px;
  padding: 0px;
  white-space: nowrap;
  color: white;

  text-shadow: 0px 0.01em hsl(50, 50%, 45%), 0px 0.04em hsl(50, 50%, 40%),
    0px 0.05em hsl(50, 50%, 35%), 0px 0.06em hsl(50, 50%, 34%),
    0px 0.07em hsl(50, 50%, 33%), 0px 0.08em hsl(50, 50%, 32%),
    0px 0.09em hsl(50, 50%, 31%), 0px 0.1em hsl(50, 50%, 30%),
    0px 0.11em hsl(50, 50%, 29%), 0px 0.1em hsl(50, 50%, 28%),
    0px 1em 3em rgba(0, 0, 0, 0.7);

  ${({ visible, isActive }) =>
    visible
      ? isActive
        ? css`
            animation: ${pulse} 1s linear infinite;
            animation-direction: alternate-reverse;
          `
        : css`
            animation: ${showBanner} 1s linear forwards;
          `
      : css`
          opacity: 0;
        `};
`;

const BannerContainer = styled.div`
  position: absolute;
  width: 100vw;
  height: 5rem;
  top: 3rem;
  right: 0px;

  ${MyTurnBanner} {
    position: absolute;
    width: 100vw;
    height: 5rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    left: 0px;
    box-sizing: border-box;
    padding: 0rem 0.7rem;
  }
`;

interface Props {
  myTurn?: boolean;
  activePlayerName: string;
}

const Banners = ({ myTurn, activePlayerName }: Props) => {
  const { playSound } = useSoundContext();
  useEffect(() => {
    if (myTurn) {
      playSound("myTurn");
    } else {
      playSound("nextTurn");
    }
  }, [myTurn, playSound]);
  return (
    <BannerContainer className="banners">
      <MyTurnBanner
        isActive={true}
        fontSize={"5rem"}
        className="big-banner"
        visible={!!myTurn}
      >
        It's your turn!
      </MyTurnBanner>

      <MyTurnBanner
        fontSize={"3rem"}
        visible={!myTurn && activePlayerName !== ""}
      >
        Waiting for {activePlayerName}
      </MyTurnBanner>
    </BannerContainer>
  );
};

export default Banners;
